// extracted by mini-css-extract-plugin
module.exports = {"codeSnippet":"styles_codeSnippet__bnF4q","description":"styles_description__2N8fT","copy":"styles_copy__2QPc6","code":"styles_code__an4oc"};